module.exports = __webpack_public_path__ + "assets/-_12.216041aa.svg";